// Mirrors the server-side rule behind the `executableFileNotAllowed` (e1039) response — keep both lists in sync.
export const EXECUTABLE_FILE_EXTENSIONS = [
    // Windows
    '.exe',
    '.msi',
    '.msp',
    '.bat',
    '.cmd',
    '.com',
    '.scr',
    '.pif',
    '.cpl',
    '.dll',
    '.sys',
    '.hta',
    '.reg',
    '.lnk',
    '.vbs',
    '.vbe',
    '.jse',
    '.wsf',
    '.wsh',
    '.ps1',
    '.psm1',
    // macOS
    '.app',
    '.dmg',
    '.pkg',
    '.command',
    // Linux
    '.sh',
    '.bash',
    '.run',
    '.deb',
    '.rpm',
    '.appimage',
    // Cross-platform
    '.jar',
    '.apk',
    '.ipa',
] as const;

export const hasExecutableFileExtension = (fileName: string) => {
    // Windows ignores trailing dots and spaces, so `payload.exe.` still runs as an executable.
    const normalized = fileName
        .trim()
        .toLowerCase()
        .replace(/[.\s]+$/, '');

    return EXECUTABLE_FILE_EXTENSIONS.some(extension => normalized.endsWith(extension));
};
